

class ComponentPopup {
  private popupElement!: HTMLElement | null;
  private overlayElement!: HTMLElement | null;
  private closeButton!: HTMLButtonElement | null;
  private readonly POPUP_STORAGE_KEY = 'popup_shown';
  private readonly EXPIRATION_HOURS = 24;
  private readonly EXPIRATION_MS = this.EXPIRATION_HOURS * 60 * 60 * 1000;
  private popupContentData: any | null = null;

  constructor() {

    document.addEventListener('DOMContentLoaded', () => {
      this.popupElement = document.querySelector('.popup');

      if (!this.popupElement) {
        return;
      }

      this.overlayElement = this.popupElement.querySelector('.popup__overlay');
      this.closeButton = this.popupElement.querySelector('.popup__close');
      this.popupContentData = {
        text: this.popupElement.querySelector('.wysiwyg')?.innerHTML || '',
        link: this.popupElement.querySelector('.popup__buttons a')?.getAttribute('href') || '',
        image: this.popupElement.querySelector('.popup__image img')?.getAttribute('src') || ''
      };


      this.initialize();
    });
  }

  /**
   * Initialise le gestionnaire : vérifie le cookie et configure les écouteurs.
   */
  private initialize(): void {
    if (!this.popupElement) return;
    const currentHash = this.generateContentHash();
    const storedData = this.getStorageData(this.POPUP_STORAGE_KEY);

    const now = Date.now();

    // Le pop-up doit s'afficher si l'une des conditions suivantes est vraie :
    // A) Il n'y a pas de données stockées (première visite).
    // B) L'horodatage d'expiration est dépassé (24h sont écoulées).
    // C) Le hachage du contenu actuel est différent du hachage stocké (le contenu a été mis à jour).
    const shouldShowPopup = !storedData || now > storedData.expiry || storedData.hash !== currentHash;

    if (shouldShowPopup) {
      this.popupElement.classList.add('active')
      document.body.style.overflow = 'hidden';
      this.setLocalStorage(this.POPUP_STORAGE_KEY, currentHash);
      this.addEventListeners();

    } else {
      // Le cookie existe et correspond au contenu actuel : on cache
      this.popupElement.classList.remove('active')
    }
  }

  private generateContentHash(): string {
    if (!this.popupContentData) {
      return 'no_content';
    }

    const contentString =
      this.popupContentData.text +
      this.popupContentData.link +
      this.popupContentData.image;

    let hash = 5381;
    for (let i = 0; i < contentString.length; i++) {
      const char = contentString.charCodeAt(i);
      hash = ((hash << 5) + hash) + char;
    }
    return String(Math.abs(hash));
  }

  /**
   * Ajoute les écouteurs d'événements pour fermer le pop-up.
   */
  private addEventListeners(): void {
    if (this.closeButton) {
      this.closeButton.addEventListener('click', () => this.closeAndHidePopup());
    }
    if (this.overlayElement) {
      this.overlayElement.addEventListener('click', () => this.closeAndHidePopup());
    }
  }

  /**
   * Gère la fermeture du pop-up et la création du cookie.
     * @param contentHash - Le hachage du contenu à stocker.
     */
  private closeAndHidePopup = (): void => {
    if (!this.popupElement) return;
    if (this.popupElement) {
      this.popupElement.classList.remove('active')
      document.body.style.overflow = 'auto';
    }
  }

  // --- Méthodes de Gestion du localStorage ---
  /**
     * Définit une valeur dans localStorage.
     * @param key Clé sous laquelle stocker la valeur.
     * @param value Valeur à stocker.
     */
  private setLocalStorage(key: string, value: string): void {
    const expiryTime = Date.now() + this.EXPIRATION_MS;

    const dataToStore = {
      hash: value,
      expiry: expiryTime
    };
    try {
      localStorage.setItem(key, JSON.stringify(dataToStore));
    } catch (e) {
    }
  }
  /**
     * Récupère l'objet stocké dans localStorage et le parse.
     * @param key Clé du localStorage.
     * @returns L'objet { hash, expiry } ou null.
     */
  private getStorageData(key: string): { hash: string; expiry: number } | null {
    try {
      const item = localStorage.getItem(key);
      if (item) {
        // Retourne l'objet parsé
        return JSON.parse(item);
      }
    } catch (e) {
      console.error("Erreur lors de la lecture ou du parsing de localStorage:", e);
    }
    return null;
  }
}

export const componentPopup = new ComponentPopup();